import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/app/[locale]/staff-shortage-hospitality/StaffShortagePage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
